import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initFacebookPixel, fbPageView, PIXEL_ID } from '../lib/facebookPixel';

/**
 * Initializes Meta Pixel once and sends PageView on every client-side route change (React Router).
 */
export function FacebookPixel() {
  const location = useLocation();

  useEffect(() => {
    initFacebookPixel();
  }, []);

  useEffect(() => {
    fbPageView();
  }, [location.pathname, location.search]);

  if (!PIXEL_ID) return null;

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src={`https://www.facebook.com/tr?id=${encodeURIComponent(PIXEL_ID)}&ev=PageView&noscript=1`}
        alt=""
      />
    </noscript>
  );
}
